// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slow-enter-active,.slow-leave-active{transition:height .3s ease-in-out;overflow:hidden}", ""]);
// Exports
module.exports = exports;
